import type { JSX } from 'react'
import { api, call } from '@/api/client'
import { useMutation, useQuery } from '@/api/query'
import { SendWindowForm } from '@/settings/send-window/form'
import type { SendWindowValue } from '@/settings/send-window/form'
import { trimSeconds } from '@/settings/send-window/times'
import { ErrorState, Loading } from '@/ui/states'
import { SettingsStepShell } from './SettingsStepShell'
import { useSettleStep } from './settingsStep'

/** Step 8 — the send window, through the same form `/settings/send-window` uses. */
export function SendWindowStep(): JSX.Element {
  const automation = useQuery((signal) => call(() => api.GET('/api/v1/automation', { signal })), [])
  const save = useMutation((body: SendWindowValue) =>
    call(() => api.PUT('/api/v1/automation/send-window', { body })),
  )
  const { settle, failure } = useSettleStep('send_window')

  return (
    <SettingsStepShell step="send_window" failure={failure}>
      {automation.state.status === 'loading' ? <Loading label="Loading" lines={2} /> : null}
      {automation.state.status === 'error' ? (
        <ErrorState failure={automation.state.failure} onRetry={automation.refetch} />
      ) : null}
      {automation.state.status === 'ready' ? (
        <SendWindowForm
          value={{
            window_start: trimSeconds(automation.state.data.window_start),
            window_end: trimSeconds(automation.state.data.window_end),
            skip_weekends: automation.state.data.skip_weekends,
          }}
          submitLabel="Continue"
          onSubmit={async (next) => {
            const result = await save.run(next)
            if (result.ok) await settle()
            return result
          }}
        />
      ) : null}
    </SettingsStepShell>
  )
}
